import { render, staticRenderFns } from "./MerWithdrawInfoAdd.vue?vue&type=template&id=39381a85&scoped=true&"
import script from "./MerWithdrawInfoAdd.vue?vue&type=script&lang=js&"
export * from "./MerWithdrawInfoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39381a85",
  null
  
)

export default component.exports